document.addEventListener("DOMContentLoaded", function () {
  // Try to initialize immediately
  initProductTabsNavigation();

  // Also try again after a delay to ensure everything is loaded
  setTimeout(initProductTabsNavigation, 1500);

  // And one more time after a longer delay for slow connections
  setTimeout(initProductTabsNavigation, 3000);
});

function initProductTabsNavigation() {
  // Find all product tab sections
  const productTabSections = document.querySelectorAll(".m-product-tabs");

  productTabSections.forEach((section) => {
    // Check if slider is enabled
    const enableSlider = section.dataset.enableSlider === "true";
    if (!enableSlider) {
      return;
    }

    // Get the custom navigation arrows
    const prevButton = section.querySelector(".m-product-tabs-custom-prev");
    const nextButton = section.querySelector(".m-product-tabs-custom-next");
    if (!prevButton || !nextButton) {
      return;
    }

    // Force Swiper initialization if not already done
    const tabContents = section.querySelectorAll(".m-tab-content");

    // Find the active tab first
    let activeTab = section.querySelector(".m-tab-content.active");
    if (!activeTab && tabContents.length > 0) {
      // If no active tab, set the first one as active
      activeTab = tabContents[0];
      activeTab.classList.add("active");
    }

    tabContents.forEach((tabContent) => {
      const swiperContainer = tabContent.querySelector(".swiper-container");
      if (swiperContainer) {
        // Check if this tab is active
        const isActive = tabContent.classList.contains("active");

        // If Swiper is not initialized or needs to be reinitialized
        if (!swiperContainer.swiper || swiperContainer.swiper.destroyed) {
          // Get the number of columns from the CSS variable
          const gridStyle = getComputedStyle(
            swiperContainer.querySelector(".m-mixed-layout__inner")
          );
          const columns = parseInt(gridStyle.getPropertyValue("--items")) || 4;

          // Create a new Swiper instance with proper configuration
          try {
            new Swiper(swiperContainer, {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0,
              loop: true,
              loopAdditionalSlides: 4,
              speed: 300,
              observer: true,
              observeParents: true,
              watchSlidesProgress: true,
              watchSlidesVisibility: true,
              preventInteractionOnTransition: false,
              allowTouchMove: true,
              grabCursor: true,
              threshold: 5,
              resistance: false,
              resistanceRatio: 0,
            });
          } catch (error) {
            console.error("Error initializing Swiper:", error);
          }
        }

        // Make sure we have enough slides for navigation
        const slides = swiperContainer.querySelectorAll(".swiper-slide");

        if (slides.length < 5) {
          // Clone some slides to ensure we have enough for navigation
          const slideWrapper = swiperContainer.querySelector(".swiper-wrapper");
          const slidesToClone = Math.min(slides.length, 4);

          for (let i = 0; i < slidesToClone; i++) {
            const clonedSlide = slides[i].cloneNode(true);
            slideWrapper.appendChild(clonedSlide);
          }

          // Update Swiper after adding slides
          if (swiperContainer.swiper) {
            try {
              swiperContainer.swiper.update();
            } catch (error) {
              console.error("Error updating Swiper:", error);
            }
          }
        }

        // If this is the active tab, make sure Swiper is properly initialized
        if (isActive && swiperContainer.swiper) {
          try {
            swiperContainer.swiper.update();
          } catch (error) {
            console.error("Error updating active Swiper:", error);
          }
        }
      }
    });

    // Remove any existing event listeners to prevent duplicates
    const newPrevButton = prevButton.cloneNode(true);
    const newNextButton = nextButton.cloneNode(true);
    prevButton.parentNode.replaceChild(newPrevButton, prevButton);
    nextButton.parentNode.replaceChild(newNextButton, nextButton);

    // Direct connection to Swiper navigation with error handling
    newPrevButton.addEventListener("click", function (e) {
      e.preventDefault();
      try {
        const activeTab = section.querySelector(".m-tab-content.active");
        if (!activeTab) {
          return;
        }

        const swiperContainer = activeTab.querySelector(".swiper-container");
        if (swiperContainer && swiperContainer.swiper) {
          // Force update before sliding
          swiperContainer.swiper.update();
          // Enable loop mode if not already enabled
          if (!swiperContainer.swiper.params.loop) {
            swiperContainer.swiper.params.loop = true;
            swiperContainer.swiper.update();
          }
          swiperContainer.swiper.slidePrev();
        } else {
          // Try to initialize Swiper if it doesn't exist
          if (swiperContainer && !swiperContainer.swiper) {
            initProductTabsNavigation();
          }
        }
      } catch (error) {
        console.error("Error in prev button click:", error);
      }
    });

    newNextButton.addEventListener("click", function (e) {
      e.preventDefault();
      try {
        const activeTab = section.querySelector(".m-tab-content.active");
        if (!activeTab) {
          return;
        }

        const swiperContainer = activeTab.querySelector(".swiper-container");
        if (swiperContainer && swiperContainer.swiper) {
          // Force update before sliding
          swiperContainer.swiper.update();
          // Enable loop mode if not already enabled
          if (!swiperContainer.swiper.params.loop) {
            swiperContainer.swiper.params.loop = true;
            swiperContainer.swiper.update();
          }
          swiperContainer.swiper.slideNext();
        } else {
          // Try to initialize Swiper if it doesn't exist
          if (swiperContainer && !swiperContainer.swiper) {
            initProductTabsNavigation();
          }
        }
      } catch (error) {
        console.error("Error in next button click:", error);
      }
    });

    // Handle tab switching with Swiper update
    const tabHeaders = section.querySelectorAll(".m-tab-header");
    tabHeaders.forEach((header) => {
      // Remove existing event listeners to prevent duplicates
      const newHeader = header.cloneNode(true);
      header.parentNode.replaceChild(newHeader, header);

      newHeader.addEventListener("click", function () {
        // Get the target tab content
        const tabId = this.getAttribute("href");
        const tabContent = document.querySelector(tabId);
        if (!tabContent) {
          return;
        }

        // Mark this tab as active
        const allTabContents = section.querySelectorAll(".m-tab-content");
        allTabContents.forEach((tab) => tab.classList.remove("active"));
        tabContent.classList.add("active");

        // Update the Swiper in the newly active tab
        setTimeout(() => {
          const swiperContainer = tabContent.querySelector(".swiper-container");
          if (swiperContainer) {
            if (swiperContainer.swiper) {
              try {
                // Make sure loop mode is enabled
                swiperContainer.swiper.params.loop = true;
                swiperContainer.swiper.update();
              } catch (error) {
                console.error("Error updating Swiper after tab switch:", error);
              }
            } else {
              // If Swiper is not initialized, try to initialize it
              initProductTabsNavigation();
            }
          }
        }, 100);
      });
    });

    // Enable drag functionality by adding touch events
    tabContents.forEach((tabContent) => {
      const swiperContainer = tabContent.querySelector(".swiper-container");
      if (swiperContainer && swiperContainer.swiper) {
        try {
          // Ensure touch events are enabled
          swiperContainer.swiper.params.touchRatio = 1;
          swiperContainer.swiper.params.touchStartPreventDefault = false;
          swiperContainer.swiper.params.touchStartForcePreventDefault = false;
          swiperContainer.swiper.params.touchMoveStopPropagation = false;
          swiperContainer.swiper.update();
        } catch (error) {
          console.error("Error enabling touch events:", error);
        }
      }
    });
  });
}
